import React from "react";
import { Form, Input, InputNumber, Space, Table } from "antd";
import { EvaluationViewpointDetail } from "./ScoringPage";
import {
  onScoreChanged,
  setPersonNodes,
  setSummary,
  validatorCheckScore,
} from "./ScoringTable1";
import { ScoringTableProps } from "./ScoringTable";
import { Messages } from "../Common/ValidateMessages";
import { isEmptyString } from "../Common/Utils";

export const ScoringTable7 = ({
  showPersonInfo,
  showPersonInfoItemFlags,
  useCase,
  scoringType,
  evaluations,
  applicants,
  onDocumentLinkClick,
  afMap,
}: ScoringTableProps) => {
  const [columns, setColumns] = React.useState<any[]>([]);
  const [detailDatas, setDetailDatas] = React.useState<
    EvaluationViewpointDetail[]
  >([]);

  React.useEffect(() => {
    const datas: EvaluationViewpointDetail[] = [];
    evaluations.forEach((evaluation, evaluationIndex) => {
      evaluation.evaluationViewpointDetailList.forEach(
        (detail, detailIndex) => {
          datas.push(detail);
        }
      );
    });
    setDetailDatas(datas);
    const tCloumns: any[] = [];
    tCloumns.push({
      title: <div className="table-title">No</div>,
      className: "table-center-cell",
      width: "100px",
      key: `evaluationCriteria`,
      render: (value: any, item: EvaluationViewpointDetail, index: number) => (
        <span>{index + 1}</span>
      ),
      fixed: "left",
    });
    if (applicants) {
      applicants.forEach((applicant, applicantIndex) => {
        const childrenCloumns: any[] = [
          {
            title: <div className="table-title">評価コメント</div>,
            width: "200px",
            key: "evaluationComment",
            render: (
              value: any,
              item: EvaluationViewpointDetail,
              index: number
            ) => {
              const initValue =
                applicant.userScoringResult?.resultDetails &&
                applicant.userScoringResult?.resultDetails != null
                  ? applicant.userScoringResult?.resultDetails.find(
                      (resultDetailElement) =>
                        resultDetailElement &&
                        resultDetailElement != null &&
                        resultDetailElement.evaluationViewpointDetailId ===
                          item.evaluationViewpointDetailId
                    )
                  : null;
              if (useCase === "1") {
                const controlName = `comment_${applicant.applicantId}_${item.evaluationViewpointDetailId}`;
                return (
                  <Form.Item
                    label=""
                    name={controlName}
                    initialValue={initValue?.evaluationComment}
                    rules={[
                      {
                        max: 100,
                        type: "string",
                        message: Messages["ERR-053"],
                      },
                    ]}
                  >
                    <Input.TextArea maxLength={100} />
                  </Form.Item>
                );
              } else if (
                useCase === "2" ||
                useCase === "3" ||
                useCase === "4"
              ) {
                const resultSpans: string[] = [];
                applicant.scoringResults.forEach(
                  (scoringResult, scoringResultIndex) => {
                    const resultDetail = scoringResult.resultDetails.find(
                      (resultDetailElement) =>
                        resultDetailElement.evaluationViewpointDetailId ===
                        item.evaluationViewpointDetailId
                    );
                    const comentValue = isEmptyString(
                      resultDetail?.evaluationComment
                    )
                      ? resultDetail?.evaluationComment
                      : "コメントなし";
                    resultSpans.push(
                      `${scoringResult.sei} ${scoringResult.mei} コメント\n${comentValue}`
                    );
                  }
                );
                return (
                  <Input.TextArea
                    value={resultSpans.join("\n")}
                    readOnly={true}
                  />
                );
              }
              return "";
            },
          },
          {
            title: <div className="table-title">評価点</div>,
            width: "180px",
            key: "totalScore",
            className: "table-score-cell",
            onCell: (_, index) => {
              if (index === 0) {
                return { rowSpan: datas.length };
              } else {
                return { rowSpan: 0 };
              }
            },
            render: (
              value: any,
              item: EvaluationViewpointDetail,
              index: number
            ) => {
              const initValue =
                applicant.userScoringResult?.resultDetails &&
                applicant.userScoringResult?.resultDetails != null
                  ? applicant.userScoringResult?.resultDetails.find(
                      (resultDetailElement) =>
                        resultDetailElement &&
                        resultDetailElement != null &&
                        resultDetailElement.evaluationViewpointDetailId ===
                          item.evaluationViewpointDetailId
                    )
                  : null;
              if (useCase === "1") {
                const controlName = `score_${applicant.applicantId}_${item.evaluationViewpointDetailId}`;
                const afFlag = afMap.get(applicant.applicantId);
                return (
                  <Form.Item label="" className="score-input-form-item">
                    <Form.Item
                      noStyle
                      name={controlName}
                      initialValue={initValue?.score}
                      rules={
                        afFlag
                          ? []
                          : [
                              {
                                required: true,
                                message: Messages["ERR-051"],
                              },
                              {
                                validator: (_: any, value: any) =>
                                  validatorCheckScore(
                                    value,
                                    item.lowScore,
                                    item.highScore
                                  ),
                              },
                            ]
                      }
                    >
                      <InputNumber
                        disabled={afFlag}
                        className="score-input-number-control"
                        keyboard={true}
                        onChange={(v: number) =>
                          onScoreChanged(v, applicant.applicantId, controlName)
                        }
                      />
                    </Form.Item>
                    /{item.highScore}
                  </Form.Item>
                );
              } else if (useCase === "2") {
                const resultSpans: any[] = [];
                const controlName = `score_${applicant.applicantId}_${item.evaluationViewpointDetailId}`;
                applicant.scoringResults.forEach(
                  (scoringResult, scoringResultIndex) => {
                    const resultDetail = scoringResult.resultDetails.find(
                      (resultDetailElement) =>
                        resultDetailElement.evaluationViewpointDetailId ===
                        item.evaluationViewpointDetailId
                    );
                    resultSpans.push(
                      <span>
                        {scoringResult.sei}
                        {scoringResult.mei}:
                        <span className="scoreSpan">{resultDetail?.score}</span>
                      </span>
                    );
                  }
                );
                return (
                  <Space direction="vertical">
                    {resultSpans}
                    <Form.Item className="score-input-form-item">
                      確定値:&nbsp;
                      <Form.Item
                        label=""
                        noStyle
                        name={controlName}
                        initialValue={initValue?.score}
                        rules={[
                          {
                            required: true,
                            message: Messages["ERR-051"],
                          },
                          {
                            validator: (_: any, value: any) =>
                              validatorCheckScore(
                                value,
                                item.lowScore,
                                item.highScore
                              ),
                          },
                        ]}
                      >
                        <InputNumber
                          className="score-input-number-control"
                          keyboard={true}
                          onChange={(v: number) =>
                            onScoreChanged(
                              v,
                              applicant.applicantId,
                              controlName
                            )
                          }
                        />
                      </Form.Item>
                      /{item.highScore}
                    </Form.Item>
                  </Space>
                );
              } else if (useCase === "3") {
                const resultInputs: any[] = [];
                applicant.scoringResults.forEach(
                  (scoringResult, scoringResultIndex) => {
                    const resultDetail = scoringResult.resultDetails.find(
                      (resultDetailElement) =>
                        resultDetailElement.evaluationViewpointDetailId ===
                        item.evaluationViewpointDetailId
                    );
                    const controlName = `score_${applicant.applicantId}_${scoringResult.userId}_${item.evaluationViewpointDetailId}`;
                    resultInputs.push(
                      <Form.Item className="score-input-form-item">
                        {scoringResult.sei}
                        {scoringResult.mei}:&nbsp;
                        <Form.Item
                          label=""
                          noStyle
                          name={controlName}
                          initialValue={resultDetail?.score}
                          rules={[
                            {
                              required: true,
                              message: Messages["ERR-051"],
                            },
                            {
                              validator: (_: any, value: any) =>
                                validatorCheckScore(
                                  value,
                                  item.lowScore,
                                  item.highScore
                                ),
                            },
                          ]}
                        >
                          <InputNumber
                            className="score-input-number-control"
                            keyboard={true}
                            onChange={(v: number) =>
                              onScoreChanged(
                                v,
                                `${applicant.applicantId}_${scoringResult.userId}`,
                                controlName
                              )
                            }
                          />
                        </Form.Item>
                        /{item.highScore}
                      </Form.Item>
                    );
                  }
                );
                return <Space direction="vertical">{resultInputs}</Space>;
              } else if (useCase === "4") {
                const resultLabels: any[] = [];
                applicant.scoringResults.forEach(
                  (scoringResult, scoringResultIndex) => {
                    const resultDetail = scoringResult.resultDetails.find(
                      (resultDetailElement) =>
                        resultDetailElement.evaluationViewpointDetailId ===
                        item.evaluationViewpointDetailId
                    );
                    resultLabels.push(
                      <span>
                        {scoringResult.sei}
                        {scoringResult.mei}:
                        <span className="scoreSpan">{resultDetail?.score}</span>
                      </span>
                    );
                  }
                );
                resultLabels.push(
                  <span className="confirmSpan">
                    確定値:
                    <span className="scoreSpan">{initValue?.score}</span>
                  </span>
                );
                return <Space direction="vertical">{resultLabels}</Space>;
              }
              return "";
            },
          },
        ];
        if (scoringType === "2" && showPersonInfo) {
          const titleNodes = setPersonNodes(
            applicant,
            scoringType,
            useCase,
            onDocumentLinkClick,
            7,
            showPersonInfoItemFlags
          );
          tCloumns.push({
            title: (
              <Space
                direction="vertical"
                align="center"
                size={0}
                style={{ width: "100%" }}
              >
                {titleNodes}
              </Space>
            ),
            key: `applicant_${applicantIndex}`,
            children: childrenCloumns,
          });
        } else {
          tCloumns.push(...childrenCloumns);
        }
      });
    }

    setColumns(tCloumns);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [evaluations, showPersonInfo, afMap]);

  return (
    <div style={{ width: "100%", textAlign: "center" }}>
      <Table
        bordered
        rowKey={(record: any) => record.evaluationViewpointDetailId}
        showSorterTooltip={false}
        columns={columns}
        dataSource={detailDatas}
        // onChange={this.onChange}
        pagination={false}
        summary={(_) => setSummary(useCase, applicants, 1, 2)}
        scroll={{ x: applicants.length > 1 ? 300 * applicants.length : true }}
      />
    </div>
  );
};
